module.exports = __webpack_public_path__ + "media/images/menu/circinus-56d831d8e606481cb3c2dc60d19d196e.jpg";